import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

import styled from "styled-components";

const ScrollStyle = styled.div`
  overflow: hidden visible;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #424b59;
  }

  h1 {
    font-size: 20px;
    font-weight: 500;
  }

  h2 {
    font-size: 17px;
    font-weight: 500;
  }

  h3 {
    font-size: 15px;
    font-weight: 400;
  }

  h4 {
    font-size: 12px;
    font-weight: 300;
  }
`;

const SntMarkdown = ({ text, className = "", height }) => {
  if (!text) return <></>;

  return (
    <ScrollStyle style={{ height: height }}>
      <Markdown
        remarkPlugins={[remarkGfm]}
        className={className}
        components={{
          a: ({ node, href, ...props }) => {
            // Decode HTML entities in the href to handle &amp; -> &
            const decodedHref = href ? href.replace(/&amp;/g, "&") : href;
            return <a href={decodedHref} {...props} />;
          },
          // table: ({ node, ...props }) => (
          //   <table className="table table-bordered table-striped" {...props} />
          // ),
        }}
      >
        {text}
      </Markdown>
    </ScrollStyle>
  );
};

export default SntMarkdown;
